import { createFileRoute } from '@tanstack/react-router';
import { RolesTable } from '../../components/tenant/RolesTable';

export const Route = createFileRoute('/_authenticated/_layout/tenant/roles/')({
    component: () => <RolesTable />,
});
